export default __webpack_public_path__ + "static/media/marauders-map-v4-01-03.39611059.jpg";